import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';


const ClassAssembly9A2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/6.webp`;
const p7 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/7.webp`;
const p8 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/8.webp`;
const p9 = `${config.base_image_url_2025}/home/events-activities/class-assembly/9A/9.webp`;

  
  

  
 

  const photos = [
    
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
}


  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
       BAAL KAAND
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 9A Date: 15 & 16 September 2025

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The Real Decision Makers in Agriculture”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        Students of Class 9A presented an inspiring assembly on the topic “BAAL KAAND”, a part of the Ramcharitmanas by Tulsidas and the first book of the Valmiki Ramayana on Tuesday, 16 September 2025. The assembly commenced with a divine Chaupai followed by magnificent musical drama and an enthusiastic dance performance, marked by fluid movements and palpable energy which completely captivated the audience from the start to finish. The assembly focused on prince Rama's birth, childhood and adolescence, as well as his education in scriptures and warfare. The performance conveyed the message “duty, righteousness, devotion and family bonds, offering moral lessons on growth through challenges, respect for elders “. The message was well received and appreciated by the audience.
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “In Baal Kaand shines the child divine, Where Rama’s laughter makes the world align;
    In innocence dwells the highest light, Guiding hearts to truth and right.”

   <br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly9A2025;